const NotFound = () =>{
    return(
        <div style={{ display:"flex",width:"100%", margin:"20px auto", justifyContent:"center"}}>
            <img src={ require("Media/404.jpg")} alt="Service not found"/>
        </div>
    )
}

export default NotFound;